import {View} from 'native-base';
import React, {useEffect} from 'react';

import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

import PRFormField from '../PRFormField';
import {PRDescription, PRSubtitle} from '../PRLabels';
import PRPageTemplate from '../PRPageTemplate';

export interface PRNewPasswordEntryProps {
  loading: boolean;
  footerOnPress: () => void;
  password: string;
  setPassword: (value: string) => void;
  passwordErrors: string[];
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  confirmPasswordErrors: string[] | undefined;
  checkFirstField: () => void;
  footerButtonDisabled: boolean;
  containsUppercase: boolean;
  containsLowercase: boolean;
  containsNumber: boolean;
  containsSpecialCharacter: boolean;
}

const PRNewPasswordEntry: React.FC<PRNewPasswordEntryProps> = (props) => {
  const {
    loading,
    footerOnPress,
    password,
    setPassword,
    passwordErrors,
    confirmPassword,
    confirmPasswordErrors,
    setConfirmPassword,
    checkFirstField,
    footerButtonDisabled,
    containsUppercase,
    containsLowercase,
    containsNumber,
    containsSpecialCharacter,
  } = props;

  const {trackAdobeEvent} = useTrackEvent();

  useEffect(() => {
    trackAdobeEvent({
      event: AdobeEvent.pageLoad,
      page: {
        name: 'password reset update password entry',
      },
    });
  }, []);

  return (
    <PRPageTemplate
      footerCTALabel="Submit"
      footerButtonDisabled={footerButtonDisabled}
      footerOnPress={footerOnPress}
      title="Create Password"
      loading={loading}
      testID="new-password-entry"
    >
      <View>
        <PRSubtitle>Enter your new password</PRSubtitle>
        <View mt={4} width="100%" alignItems="center">
          <PRFormField
            onChangeText={setPassword}
            placeholder="Password"
            maskedInput
            dangerText={passwordErrors}
            testID="password-field"
            value={password}
            accessibility={{
              accessible: true,
              accessibilityLabel: 'enter password',
              accessibilityRole: 'text',
              accessibilityHint: 'enter password',
              keyboardType: 'default',
            }}
          />
          <PRFormField
            onChangeText={setConfirmPassword}
            placeholder="Re-enter Password"
            maskedInput
            onFocus={checkFirstField}
            dangerText={confirmPasswordErrors}
            testID="confirm-password-field"
            value={confirmPassword}
            accessibility={{
              accessible: true,
              accessibilityLabel: 'confirm password',
              accessibilityRole: 'text',
              accessibilityHint: 'confirm password',
              keyboardType: 'default',
            }}
          />
        </View>
        <View>
          <PRDescription isValid={false} testID="new-password-length-req">
            Password must be 13-20 characters and contain at least 3 of the
            following:
          </PRDescription>
        </View>

        <PRDescription
          isValid={containsUppercase}
          bulleted
          testID="new-password-uppercase-req"
        >
          1 uppercase letter
        </PRDescription>
        <PRDescription
          isValid={containsLowercase}
          bulleted
          testID="new-password-lowercase-req"
        >
          1 lowercase letter
        </PRDescription>
        <PRDescription
          isValid={containsNumber}
          bulleted
          testID="new-password-number-req"
        >
          1 number
        </PRDescription>
        <PRDescription
          isValid={containsSpecialCharacter}
          bulleted
          testID="new-password-special-character-req"
        >
          1 special character @’.~#$%^*-+=!_
        </PRDescription>
      </View>
    </PRPageTemplate>
  );
};

export default PRNewPasswordEntry;
